/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import { renderShortDateAndTimeForColumn } from '../../../../helpers/date-helpers';
import { ColumnTexts } from '../../../../enums';

export interface DateColumnProps {
    value: string | number | Date | null;
    shortDateFormat: string;
    shortTimeFormat: string;
}

export const DateColumn: React.FC<DateColumnProps> = ({ value = ColumnTexts.DashSymbol, shortDateFormat, shortTimeFormat }) => (
    <>
        {renderShortDateAndTimeForColumn(value, shortDateFormat, shortTimeFormat)}
    </>
);

